import * as types from "../actions/types";
import {actionTypes} from "./reducerTypes";

let userInitialState = {
    domainName: "",
    myProfile: {},
    registrarDetails: {},
    registrarList: [],
    roleList: []
}


const userReducer = (state = userInitialState, action: actionTypes) => {
    switch (action.type) {
        case types.ROLE_LIST:
            return {
                ...state,
                roleList: action.payload
            };
        case types.REGISTRAR_DETAIL:
            return {
                ...state,
                registrarDetails: action.payload
            };
        case types.REGISTRAR_LIST:
            return {
                ...state,
                registrarList: action.payload
            };
        case types.UPDATE_SEARCH_DOMAIN:
            return {
                ...state,
                domainName: action.payload
            };
        case types.GET_MY_PROFILE:
            return {
                ...state,
                myProfile: action.payload
            };
        case types.UPDATE_MY_PROFILE:
            return {
                ...state,
                myProfile: action.payload
            };
        default:
            return state;
    }
};

export default userReducer

